<template>
  <q-layout view="hHh Lpr lff" class="custom-font">
    <q-header elevated>
      <q-toolbar class="pragma-black">
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="toggleLeftDrawer"
        />

        <q-toolbar-title>
          <div class="row">
            <div class="col-xs-12 text-center">
              <span class="text-subtitle1">TODAS LAS EMPRESAS</span> <br>
              <q-icon name="person"></q-icon><span class="text-subtitle2">Usuario</span> <br>
            </div>
          </div>
          
          
        </q-toolbar-title>
        <q-btn
          class="pragma-black pragma-text-black"
          flat
          v-if="route.name === 'searchAprobar'"
          icon="more_vert"
        ></q-btn>
        <q-btn flat color="white" icon="more_vert" v-if="route.name !== 'searchAprobar'">
          <q-menu class="bg-pragma-secon custom-font">
            <q-list style="min-width: 180px" dark separator dense>
              <q-item
                clickable
                v-close-popup
                @click="changePage(section)"
                v-for="section in sections"
                :key="section.name"
              >
                <div class="row full-width flex flex-center">
                  <div class="col-xs-2" :style="`color: #${section.color}`">
                    <q-icon name="circle"></q-icon>
                  </div>
                  <div class="col-xs-8">
                    {{ section.name }}
                  </div>
                  <div class="col-xs-2 text-right">
                    {{ section.cantidad }}
                  </div>
                </div>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>

      </q-toolbar>
    </q-header>
    
    <q-drawer
      v-model="show_drawer"
      :width="250"
      class="bg-blue-grey text-white"
    >
      <bar-menu-global />
    </q-drawer>
    <q-page-container>
      <detalle-solicitud />
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </q-page-container>
  </q-layout>
</template>

<script>
// import axios from 'axios'
import {inject, ref} from 'vue'
// import {useQuasar} from 'quasar'
import axios from 'axios'

// import util from '../../plugins/util'
import { useRoute } from 'vue-router'
import DetalleSolicitud from '../../views/global/usuario/dialogs/DetalleSolicitudGlobalUsuario.vue'
import BarMenuGlobal from '../../components/BarMenuGlobal.vue'

export default {
  name: 'MainLayout',
  components: {
    DetalleSolicitud,
    BarMenuGlobal
  },
  setup () {
    // Variables reactivas y no reactivas
    // const $q = useQuasar()
    const bus = inject('bus')
    // const router = useRouter()
    const route = useRoute()

    const show_drawer = ref(false)
    const sections = ref([
      {
        name: 'EN CURSO',
        title: 'SOLICITUDES EN CURSO',
        link: 'global/en_curso',
        color: '1ABB9C',
        cantidad: 0
      },
      {
        name: 'POR RENDIR',
        title: 'SOLICITUDES POR RENDIR',
        link: 'global/por_rendir',
        color: '9B59B6',
        cantidad: 0
      },
      {
        name: 'OBSERVADAS',
        title: 'SOLICITUDES OBSERVADAS',
        link: 'global/observadas',
        color: 'F39C12',
        cantidad: 0
      },
      {
        name: 'RECHAZADAS',
        title: 'SOLICITUDES RECHAZADAS',
        link: 'global/rechazadas',
        color: 'E74C3C',
        cantidad: 0
      },
      {
        name: 'RENDIDAS',
        title: 'SOLICITUDES RENDIDAS',
        link: 'global/rendidas',
        color: '50C1CF',
        cantidad: 0
      },
      {
        name: 'FINALIZADAS',
        title: 'SOLICITUDES FINALIZADAS',
        link: 'global/finalizadas',
        color: '3498DB',
        cantidad: 0
      }
    ])

    // Métodos y funciones
    const changePage = (section) => {
      bus.emit('changePage', section)
    }

    const getEstadosEmpresa = async () => {
      let res = await axios.get(`json/cantidad/estados.global?section=global-usuario`)
      sections.value.forEach(elem => {
        switch (elem.name) {
          case 'EN CURSO':
            elem.cantidad = res.data.curso
            break
          case 'POR RENDIR':
            elem.cantidad = res.data.rendiciones
            break
          case 'OBSERVADAS':
            elem.cantidad = res.data.observadas
            break
          case 'RECHAZADAS':
            elem.cantidad = res.data.rechazadas
            break
          case 'RENDIDAS':
            elem.cantidad = res.data.rendidas
            break
          case 'FINALIZADAS':
            elem.cantidad = res.data.finalizadas
            break
        }
      })
    }

    // Creación del componente
    // Limpieza de eventos
    bus.all.clear()
    // util.verifyRol([8]) // Roles permitidos
    bus.on('recargaEstados', () => {
      getEstadosEmpresa()
    })
    getEstadosEmpresa()
    
    // Retorno de variables de la plantilla
    return {
      show_drawer,
      toggleLeftDrawer () {
        show_drawer.value = !show_drawer.value
      },
      changePage,
      route,
      sections
    }
  }
}
</script>

<style>
.estados {
  min-width: 40px;
}
</style>